import { useEffect, useState } from 'react';

interface PaginationInfo {
  prevPage: number | null;
  nextPage: number | null;
  mainPathPart: string;
}

interface LocalesList {
  UA: string;
}

const usePagination = (
  total: number,
  queryRouterParams: string[],
  domainUrl: string,
  localeValue: string,
  localesList: LocalesList,
  pageNumber: number,
  pageSize: number
): PaginationInfo => {
  const totalPage = Math.ceil(total / pageSize);
  const getPageNumber = (params: string[]): number => {
    const pageParam = params.find((param) => param.startsWith('page-'));
    return pageParam && !Number.isNaN(pageNumber) ? pageNumber : 1;
  };

  const [paginationInfo, setPaginationInfo] = useState<PaginationInfo>({
    prevPage: null,
    nextPage: null,
    mainPathPart: ''
  });

  useEffect(() => {
    const currentPage = getPageNumber(queryRouterParams);
    const prevPage = currentPage > 1 ? currentPage - 1 : null;
    const nextPage = currentPage < totalPage ? currentPage + 1 : null;

    const mainPathPart = `${domainUrl}${
      localeValue === localesList.UA ? '' : `/${localeValue}`
    }`;

    setPaginationInfo({
      prevPage,
      nextPage,
      mainPathPart
    });
  }, [
    total,
    JSON.stringify(queryRouterParams),
    domainUrl,
    localeValue,
    JSON.stringify(localesList),
    pageNumber
  ]);

  return paginationInfo;
};

export default usePagination;
